// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"366": "9154912f","606": "843e20d1","72": "f768f50c","985": "482cb750",}[chunkId] + ".css"
}